import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { fadeIn } from '../../../animations/fadeIn'
import { Loading, LoadingService } from '../../../services/loading.service'

@Component({
    selector: 'app-data-loading',
    templateUrl: './data-loading.component.html',
    styleUrls: ['./data-loading.component.scss'],
    animations: [fadeIn],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataLoadingComponent implements OnInit, OnDestroy {
  destroy$ = new Subject()
  loading: Loading

  constructor(
    private loadingService: LoadingService,
    private cdr: ChangeDetectorRef
  ) {}

  /* istanbul ignore next */
  ngOnInit(): void {
    this.loadingService.loading$.pipe(takeUntil(this.destroy$)).subscribe((loading) => {
      this.loading = loading
      this.cdr.markForCheck()
    })
  }

  /* istanbul ignore next */
  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
  }
}
